import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { StyledListItem } from "../SongList.style";
import SongListItem from "./SongListItem";
import { useSelector } from "react-redux";
import { colorsSelector } from "@redux/colorPalette/selectors";
import type { Song } from "src/@types/api-types";
import { favoritePlaylistSelector } from "@redux/session/selectors";

interface Props {
	item: {
		globalIndex: number;
		song: Song;
	};
	elapsedTime?: boolean;
}

const SortableSongItem = ({ item, elapsedTime }: Props) => {
	const favoritePlaylist = useSelector(favoritePlaylistSelector);
	const favoriteSongsIds = favoritePlaylist?.playlistSongs?.map(({ song }) => song.id) || [];

	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({ id: item.globalIndex.toString() });

	const colors = useSelector(colorsSelector);

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		opacity: isDragging ? 0.5 : 1,
		zIndex: isDragging ? 1000 : "auto",
	};

	return (
		<div ref={setNodeRef} style={style}>
			<StyledListItem colors={colors}>
				<SongListItem
					index={item.globalIndex}
					song={item.song}
					elapsedTime={elapsedTime}
					dragHandleAttributes={attributes}
					dragHandleListeners={listeners}
					isLiked={favoriteSongsIds.includes(item.song.id)}
				/>
			</StyledListItem>
		</div>
	);
};

export default SortableSongItem;
